import { render, staticRenderFns } from "./talk_shaixuan.vue?vue&type=template&id=1cb4426f&scoped=true&"
import script from "./talk_shaixuan.vue?vue&type=script&lang=js&"
export * from "./talk_shaixuan.vue?vue&type=script&lang=js&"
import style0 from "./talk_shaixuan.vue?vue&type=style&index=0&id=1cb4426f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb4426f",
  null
  
)

export default component.exports